// import "@hotwired/turbo-rails"
import Rails from '@rails/ujs';
Rails.start();

import { start as startTurboLinks } from "turbolinks";
startTurboLinks();

import "@nathanvda/cocoon";

import swal from 'sweetalert2';
window.Swal = swal;
